import englishMessages from "./en";

export const getText = () => englishMessages;
